import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'
import { PeriodTypeView } from '@/types'

type Store = {
  view: PeriodTypeView
  setView: (view: PeriodTypeView) => void
}

export const useCapitalStructureStore = create<Store>()(
  devtools(
    persist(
      set => ({
        view: `monthly`,
        setView: view => set({ view })
      }),
      {
        name: `capital-structure_store`,
        storage: createJSONStorage(() => sessionStorage)
      }
    )
  )
)
